import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propArrayNum, propArrayShape, propFunc, propStr, } from '../../../../../helpers/custom-prop-types';
import SearchFilterCheck from './SearchFilterCheck';
const SearchFilterItems = (props) => {
    const { inputItems, inputName, onChangeInputFilter, viewItems } = props;
    return (_jsx("ul", Object.assign({ className: 'search_list_filter_check_list' }, { children: viewItems.map((item) => (_jsx(SearchFilterCheck, { checked: inputItems.includes(item.id), id: item.id, inputName: inputName, name: item.name, onChangeInputFilter: onChangeInputFilter }, item.id))) })));
};
SearchFilterItems.propTypes = {
    inputItems: propArrayNum().isRequired,
    inputName: propStr().isRequired,
    onChangeInputFilter: propFunc().isRequired,
    viewItems: propArrayShape().isRequired,
};
export default SearchFilterItems;
